import {useContext} from "react";
import CreateQRCodeContext from "../CreateQRCodeContext";
import VCardInputData from "./vcard/VCardInputData";
import WebsiteInputData from "./website/WebsiteInputData";
import ImageInputData from "./image/ImageInputData";
import PdfInputData from "./pdf/PdfInputData";

type InputDataProps = {
    dontShowFallback?: boolean;
}

/**
 * Input data for QRCode like (for VCard) first and last name, or URL for Link kind QRCode.
 * Must be in CreateQRCodeContext.
 * Actually does nothing...
 * @author Kacper Faber
 * @since 0.1.8
 * @constructor
 */
function InputData(props: InputDataProps) {
    /**
     * Create QR code context.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const ctx = useContext(CreateQRCodeContext);

    const renderComponent = () => {
        if (ctx.kind == 'vcard') {
            return (
                <VCardInputData/>
            );
        }

        else if (ctx.kind == 'website') {
            return (
                <WebsiteInputData/>
            );
        }

        else if (ctx.kind == 'image') {
            return (
                <ImageInputData/>
            );
        }

        else if (ctx.kind == 'pdf') {
            return (
                <PdfInputData/>
            );
        }
    }

    // Check, return fallback or nothing.
    if (ctx.kind == null) {
        if (props.dontShowFallback === true) {
            return (
                <></>
            );
        }

        return (
            <h5>
                Proszę wybrać typ kodu QR
            </h5>
        );
    }

    return (
        <div>
            { renderComponent() }
        </div>
    );
}

export default InputData;

// TODO: InputData.tsx
//  Implement component.